import React, {useId} from 'react';
import {Divider, Stack, Tab, Tabs} from '@mui/material';

const LeftPanelTabs = ({tabs, activeTab, onChange, ariaLabel = 'Left panel tabs'}) => {
    const baseId = useId();
    const tabValues = tabs.map(tab => tab.value);
    const safeActiveTab = tabValues.includes(activeTab) ? activeTab : tabValues[0];

    return (
        <React.Fragment>
            <Stack bgcolor="white">
                <Tabs
                    value={safeActiveTab}
                    onChange={onChange}
                    variant="fullWidth"
                    aria-label={ariaLabel}
                    sx={{
                        px: 0.5,
                        minHeight: 48,
                        '& .MuiTabs-flexContainer': {
                            width: '100%',
                        },
                    }}
                >
                    {tabs.map((tab) => {
                        const tabId = `${baseId}-${tab.value}-tab`;
                        const panelId = `${baseId}-${tab.value}-panel`;
                        return (
                            <Tab
                                key={tab.value}
                                value={tab.value}
                                label={tab.label}
                                id={tabId}
                                aria-controls={panelId}
                                sx={{
                                    minWidth: 0,
                                    flex: '1 1 0',
                                    px: 0.25,
                                    py: 1,
                                    fontSize: '0.8125rem',
                                    textTransform: 'none',
                                    whiteSpace: 'normal',
                                    lineHeight: 1.25,
                                }}
                            />
                        );
                    })}
                </Tabs>
                <Divider/>
            </Stack>

            {tabs.map((tab) => {
                const tabId = `${baseId}-${tab.value}-tab`;
                const panelId = `${baseId}-${tab.value}-panel`;
                const isActive = safeActiveTab === tab.value;
                return (
                    <Stack
                        key={tab.value}
                        role="tabpanel"
                        id={panelId}
                        aria-labelledby={tabId}
                        hidden={!isActive}
                        sx={{
                            display: isActive ? 'flex' : 'none',
                            flexDirection: 'column',
                            flex: 1,
                            overflow: 'hidden',
                            minHeight: 0,
                        }}
                    >
                        {tab.content}
                    </Stack>
                );
            })}
        </React.Fragment>
    );
};

export default LeftPanelTabs;
